import validate from "/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import password_45renewal_45global from "/src/middleware/passwordRenewal.global.ts";
import manifest_45route_45rule from "/src/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  password_45renewal_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}